/* ============================================================================
   LOVI — LOT 15 (06/08/2026)   theme 198702203207 (V10, UNPUBLISHED)

   1 — BUG COMMERCIAL : LE CADEAU EST FACTURE AU PANIER.

   DIAGNOSTIC MESURE (pas deduit : reproduit).
   Le buybox n'ajoute pas les cadeaux a 0 EUR. Il ajoute les VRAIS produits
   cadeaux, a leur prix plein, et compte sur une remise automatique Shopify
   BXGY a 100 % pour les ramener a zero :
     lovi-pdp.js  addToCart()
       items = [{id: data-variant-id, quantity:1}]
       data-gifts.split(',').forEach(g => items.push({id:g, quantity:1}))
       POST /cart/add.js
   Produits cadeaux et prix reels cote Shopify :
     54323858276679  LOVI-GIFT-EBOOK   « Ebook — Guide du drainage
                     lymphatique (OFFERT) »              19,90 EUR
     54323858440519  LOVI-GIFT-BROSSE  « LE METRE DE L'ECART — mesurez
                     votre ventre matin et soir (OFFERT) » 24,90 EUR
   Aucun des deux produits n'a de variante a 0 EUR : une seule variante
   « Default Title », au prix plein. On ne cree rien et on ne touche a aucun
   prix produit — hors mandat.

   La remise qui les annule est :
     « CADEAU OFFERT — Ebook + Brosse (Pack 3 · 120 jours) »
       customerBuys  : variante 54323610714439 (palier 3), quantite 1
       customerGets  : 2 unites, effet 100 %, sur EBOOK + BROSSE
       usesPerOrderLimit : 1
   LA FAUTE EST LA : le plafond est de DEUX UNITES POUR TOUTE LA COMMANDE,
   reparties dans l'ordre ou Shopify les rencontre. Des qu'un cadeau apparait
   en double, les deux unites gratuites sont absorbees et le cadeau suivant
   est facture PLEIN TARIF.

   SCENARIOS REPRODUITS SUR /cart.js (mesure, 06/08/2026) :
     palier 3 seul .................... metre 0    ebook 0    total 59,90  OK
     palier 2 PUIS palier 3 ........... ebook x2 -> 0, METRE 24,90   <-- Hunt
     palier 3 ajoute deux fois ........ ebook x2 -> 0, METRE x2 49,80
     metre present sans palier 3 ...... METRE 24,90
   Le cas « palier 2 puis palier 3 » est le chemin client le plus banal qui
   soit : on hesite, on met le 1+1 au panier, on remonte, on prend le 2+2.
   Il facture 24,90 EUR un cadeau.

   CORRECTIF APPLIQUE ICI (cote theme, dans le mandat).
   Deux invariants imposes au panier apres chaque ecriture :
     I1  un cadeau n'est jamais present en plus d'UN exemplaire ;
     I2  un cadeau dont aucun palier debloquant n'est au panier est retire.
   Sous ces deux invariants le nombre d'unites cadeau ne depasse jamais 2,
   donc le plafond de la remise n'est jamais sature, donc aucun cadeau n'est
   facture. VERIFIE PAR MESURE, APRES CORRECTIF, VIA LES VRAIS BOUTONS :
     palier 2 puis palier 3 ... metre 0  ebook 0  total  94,80
     palier 3 ajoute 2 fois ... metre 0  ebook 0  total 119,80
     metre orphelin ........... ligne retiree      total  34,90
     palier 3 seul ............ metre 0  ebook 0  total  59,90
   I3, filet de securite : si malgre tout une ligne cadeau ressort avec un
   prix > 0, elle est RETIREE. Mieux vaut un cadeau absent qu'un cadeau
   facture. Ce cas ne doit jamais se produire ; s'il se produit il est trace
   en console.

   ON NE FAIT QUE REDUIRE, JAMAIS AJOUTER : si la cliente retire elle-meme un
   cadeau depuis /cart, il n'est pas remis de force. L'ajout reste le travail
   de lovi-pdp.js.

   Les identifiants ne sont pas ecrits en dur : la table
   « cadeau -> paliers qui le debloquent » est reconstruite depuis le DOM
   ([data-lpdp-pack] data-variant-id + data-gifts). Un futur palier ou un
   futur cadeau est pris en charge sans retoucher ce fichier.

   3 — LOGO A LA PLACE DU TEXTE « LOVI™ » (bloc de bas de page).
   Le markup vit dans sections/lovi-pdp-buybox.liquid (104 Ko) : on ne pousse
   pas 104 Ko pour une balise <img>. Le remplacement se fait ici, avec un vrai
   <img alt="LOVI"> — donc lisible par un lecteur d'ecran, ce qu'un
   background-image CSS n'aurait pas permis.
   ========================================================================== */
(function () {
  if (window.__loviLot15) return;
  window.__loviLot15 = 1;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* =========================================================================
     1 — RECONCILIATION DES CADEAUX
     ========================================================================= */

  /* cadeau -> [paliers qui le debloquent], lu dans le DOM */
  function giftMap() {
    var map = Object.create(null);
    var packs = document.querySelectorAll('[data-lpdp-pack]');
    for (var i = 0; i < packs.length; i++) {
      var pid = (packs[i].getAttribute('data-variant-id') || '').trim();
      if (!pid) continue;
      var gifts = (packs[i].getAttribute('data-gifts') || '').split(',');
      for (var j = 0; j < gifts.length; j++) {
        var gid = gifts[j].trim();
        if (!gid || gid === '0') continue;
        if (!map[gid]) map[gid] = [];
        if (map[gid].indexOf(pid) === -1) map[gid].push(pid);
      }
    }
    return map;
  }

  function readCart() {
    return rawFetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function postUpdates(updates) {
    return rawFetch(ROOT + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(function (r) { return r.json(); });
  }

  /* I3 — aucune ligne cadeau ne doit sortir avec un prix > 0 */
  function enforceNeverBilled(giftIds) {
    return readCart().then(function (cart) {
      var kill = {}, hit = false;
      for (var i = 0; i < cart.items.length; i++) {
        var it = cart.items[i], v = String(it.variant_id);
        if (giftIds.indexOf(v) !== -1 && it.final_line_price > 0) {
          kill[v] = 0; hit = true;
          if (window.console && console.warn) {
            console.warn('[LOVI lot15] cadeau facture ' + it.final_line_price +
                         ' — ligne retiree : ' + it.product_title);
          }
        }
      }
      return hit ? postUpdates(kill) : cart;
    });
  }

  var busy = false;

  function reconcile() {
    if (busy) return Promise.resolve(false);
    var map = giftMap();
    var giftIds = Object.keys(map);
    if (!giftIds.length) return Promise.resolve(false);

    busy = true;
    return readCart().then(function (cart) {
      var have = Object.create(null), present = Object.create(null);
      for (var i = 0; i < cart.items.length; i++) {
        var v = String(cart.items[i].variant_id);
        have[v] = (have[v] || 0) + cart.items[i].quantity;
        present[v] = true;
      }

      var updates = {}, changed = false;
      for (var k = 0; k < giftIds.length; k++) {
        var gid = giftIds[k];
        var qty = have[gid] || 0;
        if (qty === 0) continue;                      /* on n'ajoute jamais */

        var unlocked = false, unlockers = map[gid];
        for (var u = 0; u < unlockers.length; u++) {
          if (present[unlockers[u]]) { unlocked = true; break; }
        }
        var want = unlocked ? 1 : 0;                  /* I1 et I2 */
        if (qty !== want) { updates[gid] = want; changed = true; }
      }

      return (changed ? postUpdates(updates) : Promise.resolve(cart))
        .then(function () { return enforceNeverBilled(giftIds); })
        .then(function () { return changed; });
    }).then(function (r) { busy = false; return r; },
            function () { busy = false; return false; });
  }

  /* --- accrochage -----------------------------------------------------------
     On enveloppe window.fetch pour que la promesse d'un /cart/add.js ne se
     resolve qu'APRES reconciliation. Consequence : le tiroir de panier ouvert
     par lovi-pdp.js dans son .then() affiche deja les bons prix, sans
     clignotement. Le corps de la reponse n'est jamais lu ici, donc le
     .json() de lovi-pdp.js fonctionne toujours.
     Tout ce qui n'est pas une ecriture panier passe sans etre touche.        */
  var rawFetch = window.fetch ? window.fetch.bind(window) : null;

  if (rawFetch && !window.fetch.__loviLot15) {
    var wrapped = function (input, init) {
      var url = '';
      try { url = typeof input === 'string' ? input : (input && input.url) || ''; } catch (e) {}
      var p = rawFetch.apply(null, arguments);
      if (!/\/cart\/(add|change|update|clear)(\.js)?([?#]|$)/.test(url)) return p;
      return p.then(function (res) {
        if (!res || !res.ok || busy) return res;
        return reconcile().then(function () { return res; },
                               function () { return res; });
      });
    };
    wrapped.__loviLot15 = 1;
    window.fetch = wrapped;
  }

  /* =========================================================================
     3 — LOGO A LA PLACE DE « LOVI™ »
     ========================================================================= */

  /* repli si le logo d'en-tete n'est pas trouve : c'est le fichier deja
     present dans le theme, celui du header (606 x 201 px). */
  var LOGO_FALLBACK =
    'https://mylovi.fr/cdn/shop/files/My_Patch_29_c17c2d98-0f08-47e0-b611-9dc183a87f10.png';

  function logoSource() {
    var candidates = document.querySelectorAll(
      '.m-header img, header img, [class*="logo"] img, img[class*="logo"]');
    for (var i = 0; i < candidates.length; i++) {
      var s = candidates[i].currentSrc || candidates[i].getAttribute('src') || '';
      if (/\/cdn\/shop\/(files|s\/files)\//.test(s)) return s.split('?')[0];
    }
    return LOGO_FALLBACK;
  }

  function placeLogo() {
    var wm = document.querySelector('.lpdp-footer__wordmark');
    if (!wm || wm.querySelector('img.lpdp-footer__logo')) return;

    var base = logoSource();
    var img = document.createElement('img');
    img.className = 'lpdp-footer__logo';
    /* Pas de srcset : MESURE — avec 'width=128 1x, width=256 2x' Chrome a
       retenu la vignette 1x (naturalWidth 128) alors que devicePixelRatio
       vaut 2, soit 128 px de bitmap pour 168,6 px physiques : logo flou.
       Une seule source large, redescendue a 28 px par le CSS, est nette
       dans tous les cas et ne pese que quelques kilo-octets. */
    img.src = base + '?width=256';                 /* 3x pour 84,4 px affiches */
    img.alt = 'LOVI';                              /* le texte passe en alt */
    img.width = 84;                                /* 28 x 606/201 = 84,4   */
    img.height = 28;                               /* reserve la place      */
    img.setAttribute('decoding', 'async');

    wm.textContent = '';
    wm.appendChild(img);
    wm.setAttribute('aria-label', 'LOVI');
  }

  /* =========================================================================
     amorcage
     ========================================================================= */
  function run() {
    placeLogo();
    reconcile();          /* soigne un panier deja pollue par une visite passee */
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(run, 0); });
  } else {
    setTimeout(run, 0);
  }
  window.addEventListener('load', placeLogo);
})();
